package br.com.texeratx.boardgametimeapp.ui.components.designsystem

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarData
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarVisuals
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

enum class AppSnackbarTone {
    Info,
    Success,
    Error,
    Warning,
}

class AppSnackbarVisuals(
    override val message: String,
    val tone: AppSnackbarTone = AppSnackbarTone.Info,
    override val actionLabel: String? = null,
    override val withDismissAction: Boolean = false,
    override val duration: SnackbarDuration = SnackbarDuration.Short,
) : SnackbarVisuals

@Composable
fun AppSnackbarHost(
    hostState: SnackbarHostState,
    modifier: Modifier = Modifier,
) {
    SnackbarHost(
        hostState = hostState,
        modifier = modifier
    ) { data ->
        AppSnackbar(data = data)
    }
}

@Composable
fun AppSnackbar(
    data: SnackbarData,
    modifier: Modifier = Modifier,
) {
    val tone = (data.visuals as? AppSnackbarVisuals)?.tone ?: AppSnackbarTone.Info

    val (container, content) = when (tone) {
        AppSnackbarTone.Success -> MaterialTheme.colorScheme.primaryContainer to MaterialTheme.colorScheme.onPrimaryContainer
        AppSnackbarTone.Error -> MaterialTheme.colorScheme.errorContainer to MaterialTheme.colorScheme.onErrorContainer
        AppSnackbarTone.Warning -> MaterialTheme.colorScheme.secondaryContainer to MaterialTheme.colorScheme.onSecondaryContainer
        AppSnackbarTone.Info -> MaterialTheme.colorScheme.inverseSurface to MaterialTheme.colorScheme.inverseOnSurface
    }

    Snackbar(
        modifier = modifier,
        snackbarData = data,
        containerColor = container,
        contentColor = content,
        actionColor = content,
        dismissActionContentColor = content,
    )
}
